<div uk-grid>
  <div class="uk-width-1-1">
    <h2>Remote Signing</h2>

    <div uk-grid class="uk-animation-slide-left-small">
      <div class="uk-width-1-1">
        <div class="uk-card uk-card-default">
          <div class="uk-card-header uk-form-horizontal">
          
            <h4>STEP 1 - Create Block (Online Device)</h4>
            <p>Create a SEND, RECEIVE or CHANGE block from a "watch-only" account. No wallet import needed.</p>

            <div class="uk-form-horizontal">
              <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-text2">Account to create a block for</label>
                <div class="uk-form-controls">
                  <div class="uk-inline uk-width-1-1">
                    <a class="uk-form-icon uk-form-icon-flip" uk-icon="icon: camera" (click)="openQR('account1','account')" uk-tooltip title="Scan from QR code"></a>
                    <input (blur)="validateDestination()" (input)="searchAddressBook()" (focus)="searchAddressBook()" (keyup.enter)="start()" [(ngModel)]="toAccountID" class="uk-input" [ngClass]="{ 'uk-form-success': toAccountStatus === 1, 'uk-form-danger': toAccountStatus === 0 }" type="text" placeholder="nano_1abc..." autocomplete="off">

                    <div *ngIf="(addressBookResults$ | async).length" [hidden]="!showAddressBook" class="nlt-dropdown uk-animation-slide-down-small uk-width-1-1 uk-card uk-card-default uk-card-body uk-position-absolute" style="z-index: 15000">
                      <ul class="uk-nav uk-nav-default">
                        <li class="uk-nav-header">Address Book Results</li>
                        <li class="uk-nav-divider"></li>
                        <li *ngFor="let book of addressBookResults$ | async">
                          <a (click)="selectBookEntry(book.account)">{{ book.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-inline uk-width-1-1">
              <button class="uk-button uk-button-primary uk-width-1-4@l uk-width-1-1" (click)="start()">CREATE</button>
            </div>
          </div>
          <div class="uk-card-header uk-form-horizontal">
            <h4>STEP 2 - Sign Block (Offline Device)</h4>
            <p><a routerLink="/qr-scan" routerLinkActive="active">Scan the unsigned QR code</a> from Step 1 <strong>OR</strong> paste the block below. Sign it using a key owning the account from step 1.<br>
            Nault can optionally be set in Offline Mode from the <a routerLink="/configure-app" routerLinkActive="active">Server Configuration</a> to avoid network notifications.</p>
            
            <div class="uk-form-horizontal">
              <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-text2">Unsigned block from step 1</label>
                <div class="uk-form-controls">
                  <div class="uk-inline uk-width-1-1">
                    <input (input)="validateUnsigned(unsignedBlock)" (keyup.enter)="navigateBlock(unsignedBlock)" [(ngModel)]="unsignedBlock" class="uk-input" [ngClass]="{ 'uk-form-success': unsignedStatus === 1, 'uk-form-danger': unsignedStatus === 0 }" type="text" placeholder="nanosign:{abc..}" autocomplete="off">
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-inline uk-width-1-1">
              <button class="uk-button uk-button-primary uk-width-1-4@l uk-width-1-1" (click)="navigateBlock(unsignedBlock)">SIGN</button>
            </div>
          </div>
          <div class="uk-card-header uk-form-horizontal">
            <h4>STEP 3 - Process Block (Online Device)</h4>
            <p><a routerLink="/qr-scan" routerLinkActive="active">Scan the signed QR code</a> from Step 2 <strong>OR</strong> paste the block below. Confirm and send it to the live network!</p>

            <div class="uk-form-horizontal">
              <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-text2">Signed block from step 2</label>
                <div class="uk-form-controls">
                  <div class="uk-inline uk-width-1-1">
                    <input (input)="validateSigned(signedBlock)" (keyup.enter)="navigateBlock(signedBlock)" [(ngModel)]="signedBlock" class="uk-input" [ngClass]="{ 'uk-form-success': signedStatus === 1, 'uk-form-danger': signedStatus === 0 }" type="text" placeholder="nanoprocess:{abc..}" autocomplete="off">
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-inline uk-width-1-1">
              <button class="uk-button uk-button-primary uk-width-1-4@l uk-width-1-1" (click)="navigateBlock(signedBlock)">PROCESS</button>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>


